module.exports = __webpack_public_path__ + "static/media/4-Reempaquetado.b639b642.jpg";